import { apiService } from "./api";

export type ConversionRole = "INPUT" | "OUTPUT";
export type CostAllocationMethod = "SALES_VALUE" | "WEIGHT" | "MANUAL";

export interface ConversionItem {
    item_id: string;
    conversion_id: string;
    product_id: string;
    role: ConversionRole;
    quantity: number;
    unit_cost: number;
    total_cost: number;
    allocation_percentage?: number;
    product?: {
        product_id: string;
        name: string;
        sku: string;
        cost_price: number;
        selling_price: number;
        weight?: number;
    };
    create_time: string;
    update_time: string;
}

export interface ProductConversion {
    conversion_id: string;
    conversion_number: string;
    status: string;
    conversion_date: string;
    cost_allocation_method?: CostAllocationMethod;
    additional_cost: number;
    notes?: string;
    created_by_user_id?: string;
    items: ConversionItem[];
    create_time: string;
    update_time: string;
}

export interface CreateConversionItemRequest {
    product_id: string;
    role: ConversionRole;
    quantity: number;
    allocation_percentage?: number;
}

export interface CreateConversionRequest {
    items: CreateConversionItemRequest[];
    cost_allocation_method?: CostAllocationMethod;
    additional_cost?: number;
    notes?: string;
}

class ProductConversionService {
    async getConversions(params?: { skip?: number; limit?: number }): Promise<ProductConversion[]> {
        const query = new URLSearchParams();
        if (params?.skip !== undefined) query.append("skip", params.skip.toString());
        if (params?.limit !== undefined) query.append("limit", params.limit.toString());
        return apiService.get<ProductConversion[]>(`/product-conversions?${query.toString()}`);
    }

    async getConversion(conversionId: string): Promise<ProductConversion> {
        return apiService.get<ProductConversion>(`/product-conversions/${conversionId}`);
    }

    async createConversion(data: CreateConversionRequest): Promise<ProductConversion> {
        return apiService.post<ProductConversion>("/product-conversions", data);
    }
}

export const productConversionService = new ProductConversionService();
